import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "../slices/index";
import { toastMiddleware } from "../middleware/toastMiddleware";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(toastMiddleware),
});

export default store;